import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Pwa } from '@freelancer/pwa';
import type { Observable } from 'rxjs';

@Component({
  selector: 'fl-language-switcher',
  template: `
    <ng-container *ngIf="!(isLoggedIn$ | flAsync); else loggedInSwitcher">
      <fl-language-switcher-link [isLoggedIn]="false" />
    </ng-container>
    <ng-template #loggedInSwitcher>
      <fl-language-switcher-link
        *ngIf="!forceInlineSwitcher"
        [isLoggedIn]="true"
        [flHideMobile]="true"
      ></fl-language-switcher-link>
      <!-- this is not an "*ngIf" because we can show either when they are not forced -->
      <fl-language-switcher-inline
        [flHideDesktop]="!forceInlineSwitcher"
        [flHideTablet]="!forceInlineSwitcher"
        [compact]="compact"
      ></fl-language-switcher-inline>
    </ng-template>
  `,
  styleUrls: ['./language-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent implements OnInit {
  /**
   * Whether or not to attach a label to the inline switcher
   **/
  @Input() compact = false;

  /**
   * Whether or not the switcher is disabled entirely.
   */
  disabled: Promise<boolean>;

  /**
   * Whether or not to force the inline language switcher.
   * Toggling this off will enable the link-based switcher on desktop
   **/
  forceInlineSwitcher: boolean;

  /**
   * Whether or not the user is logged in.
   * Display link version if logged out.
   */
  isLoggedIn$: Observable<boolean>;

  constructor(
    private auth: Auth,
    private pwa: Pwa,
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.auth.isLoggedIn();

    this.forceInlineSwitcher =
      // installed mode always sees the inline switcher
      this.pwa.isInstalled();
  }
}
